import { createSelector } from 'reselect';
import PredesImpcCodeUsageNonComplianceDetailsColumns
  from '../../containers/PredesImpcCodeUsageNonComplianceDetailsColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_DETAILS.isLoading;

export const getData =
  ReportDefinitions
    .PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, PredesImpcCodeUsageNonComplianceDetailsColumns);
